"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireWildcard(require("react"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _defaultPopup = _interopRequireDefault(require("../defaultPopup"));

var _input = _interopRequireDefault(require("../../input"));

var _baseButton = require("../../buttons/baseButton");

var _throbber = _interopRequireDefault(require("../../throbber/throbber"));

var _helpers = require("../../helpers");

var _serviceUserRequest = _interopRequireDefault(require("../../requests/serviceUserRequest"));

var _inputSimple = _interopRequireWildcard(require("../../inputSimple"));

var _constants = require("../../../assets/js/constants");

var _templateObject, _templateObject2, _templateObject3, _templateObject4, _templateObject5, _templateObject6;

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var InputPhone = (0, _styledComponents["default"])((0, _inputSimple.phoneDecorator)(_inputSimple["default"])).withConfig({
  displayName: "popupCallback__InputPhone",
  componentId: "sc-1nvxj60-0"
})(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n    width: ", ";\n    @media(max-width: 640px) { \n        width: 100%;\n    }\n"])), function (props) {
  return props.width || '100%';
});

var Container = _styledComponents["default"].div.withConfig({
  displayName: "popupCallback__Container",
  componentId: "sc-1nvxj60-1"
})(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n    flex-direction: column;\n    max-width: 680px;\n    background: #fff;\n    padding: 40px;\n    @media(max-width: 640px) { \n        padding: 30px 20px 20px;\n    }\n"])));

var Title = _styledComponents["default"].div.withConfig({
  displayName: "popupCallback__Title",
  componentId: "sc-1nvxj60-2"
})(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n    margin-bottom: 20px;\n    ", ";\n    @media(max-width: 640px) {\n        padding-right: 20px;\n    }\n"])), _constants.FONTS.H2);

var Description = _styledComponents["default"].p.withConfig({
  displayName: "popupCallback__Description",
  componentId: "sc-1nvxj60-3"
})(_templateObject4 || (_templateObject4 = _taggedTemplateLiteral(["\n    ", ";\n    margin: 0 0 20px;\n"])), _constants.FONTS.S);

var Button = (0, _styledComponents["default"])(_baseButton.BaseButton).withConfig({
  displayName: "popupCallback__Button",
  componentId: "sc-1nvxj60-4"
})(_templateObject5 || (_templateObject5 = _taggedTemplateLiteral(["\n    @media (min-width: 641px) {\n        width: 220px;\n    }\n"])));
var StyledInput = (0, _styledComponents["default"])(_input["default"]).withConfig({
  displayName: "popupCallback__StyledInput",
  componentId: "sc-1nvxj60-5"
})(_templateObject6 || (_templateObject6 = _taggedTemplateLiteral(["\n    width: ", ";\n    @media(max-width: 640px) { \n        width: 100%;\n    }\n"])), function (props) {
  return props.width || '100%';
});
var CALLBACK_URL = '/user/request-by-call';
var POLICY_URL = 'https://dom.ru/policy.pdf';
var DEFAULT_STATE = {
  validate: true,
  nameIsEmpty: true,
  phoneIsValid: false,
  waitStatus: true,
  nameInputValue: '',
  phoneInputValue: ''
};

var PopupCallback = /*#__PURE__*/function (_Component) {
  _inherits(PopupCallback, _Component);

  var _super = _createSuper(PopupCallback);

  function PopupCallback() {
    var _this;

    _classCallCheck(this, PopupCallback);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    _defineProperty(_assertThisInitialized(_this), "state", _objectSpread({}, DEFAULT_STATE));

    _defineProperty(_assertThisInitialized(_this), "onNameChange", function (value) {
      _this.setState(function () {
        return {
          nameIsEmpty: value.length <= 0,
          nameInputValue: value
        };
      });
    });

    _defineProperty(_assertThisInitialized(_this), "onPhoneChange", function (data) {
      _this.setState(function () {
        return {
          phoneIsValid: data.isValid,
          phoneInputValue: data.value
        };
      });
    });

    _defineProperty(_assertThisInitialized(_this), "handleSubmit", function (event) {
      var city = _this.props.city;
      event.preventDefault();

      _this.setState({
        waitStatus: false
      });

      var _this$state = _this.state,
          nameInputValue = _this$state.nameInputValue,
          phoneInputValue = _this$state.phoneInputValue;
      var _this$props = _this.props,
          onSuccessShow = _this$props.onSuccessShow,
          onFailureShow = _this$props.onFailureShow,
          label = _this$props.label;
      var requestType = label === 'service' ? 'request' : 'problem';
      var params = {
        params: {
          fio: nameInputValue,
          phone: phoneInputValue,
          petition: requestType,
          cityId: city.cityId
        }
      };
      (0, _serviceUserRequest["default"])(city.domain).get(CALLBACK_URL, params).then(function (res) {
        if (res.data.status === 1) {
          if (window.href === '/smart-bracelet-healbe-gobe-2') {
            (0, _helpers.dataLayerPush)({
              'event': 'promoClick',
              'ecommerce': {
                'promoClick': {
                  'promotions': [{
                    'id': 'clicked_to_confirm_order_for_hilbi_device',
                    'name': 'clicked_to_confirm_order_for_hilbi_device',
                    'creative': '1',
                    'position': 'smart-bracelet-healbe-gobe-2'
                  }]
                }
              }
            });
          } else {
            (0, _helpers.dataLayerPush)({
              'event': 'UAevent',
              'category': 'Callback form',
              'action': 'Send',
              'label': label
            });
          }

          _this.setState(function () {
            return _objectSpread({}, DEFAULT_STATE);
          }, onSuccessShow);
        } else {
          _this.setState(function () {
            return _objectSpread({}, DEFAULT_STATE);
          }, onFailureShow(res.data.message));
        }
      })["catch"](function () {
        _this.setState(function () {
          return _objectSpread({}, DEFAULT_STATE);
        }, onFailureShow);
      });
    });

    return _this;
  }

  _createClass(PopupCallback, [{
    key: "render",
    value: function render() {
      var _this$props2 = this.props,
          isOpen = _this$props2.isOpen,
          onClose = _this$props2.onClose;
      var _this$state2 = this.state,
          nameIsEmpty = _this$state2.nameIsEmpty,
          nameInputValue = _this$state2.nameInputValue,
          phoneIsValid = _this$state2.phoneIsValid,
          waitStatus = _this$state2.waitStatus;
      return /*#__PURE__*/_react["default"].createElement(_defaultPopup["default"], {
        isOpen: isOpen,
        onClose: onClose
      }, /*#__PURE__*/_react["default"].createElement(Container, null, /*#__PURE__*/_react["default"].createElement(Title, null, "\u0417\u0430\u043A\u0430\u0436\u0438\u0442\u0435 \u043E\u0431\u0440\u0430\u0442\u043D\u044B\u0439 \u0437\u0432\u043E\u043D\u043E\u043A"), /*#__PURE__*/_react["default"].createElement(Description, null, "\u041E\u0441\u0442\u0430\u0432\u044C\u0442\u0435 \u0432\u0430\u0448 \u043D\u043E\u043C\u0435\u0440 \u0442\u0435\u043B\u0435\u0444\u043E\u043D\u0430 \u0438 \u043D\u0430\u0448 \u043C\u0435\u043D\u0435\u0434\u0436\u0435\u0440 \u0441\u0432\u044F\u0436\u0435\u0442\u0441\u044F \u0441 \u0432\u0430\u043C\u0438"), /*#__PURE__*/_react["default"].createElement("form", {
        onSubmit: this.handleSubmit
      }, /*#__PURE__*/_react["default"].createElement(StyledInput, {
        width: "50%",
        value: nameInputValue,
        onChange: this.onNameChange,
        placeholder: "\u0412\u0430\u0448\u0435 \u0438\u043C\u044F",
        name: "name",
        errorMessage: "\u0423\u043A\u0430\u0436\u0438\u0442\u0435 \u0432\u0430\u0448\u0435 \u0438\u043C\u044F",
        required: true
      }), /*#__PURE__*/_react["default"].createElement(InputPhone, {
        width: "33%",
        onChange: this.onPhoneChange,
        placeholder: "\u0422\u0435\u043B\u0435\u0444\u043E\u043D",
        name: "phone1",
        errorMessage: "\u0423\u043A\u0430\u0436\u0438\u0442\u0435 \u0432\u0430\u0448 \u0442\u0435\u043B\u0435\u0444\u043E\u043D"
      }), /*#__PURE__*/_react["default"].createElement(Description, null, "\u041D\u0430\u0436\u0438\u043C\u0430\u044F \u043D\u0430 \u043A\u043D\u043E\u043F\u043A\u0443, \u0432\u044B \u0441\u043E\u0433\u043B\u0430\u0448\u0430\u0435\u0442\u0435\u0441\u044C \u043D\u0430 \u043E\u0431\u0440\u0430\u0431\u043E\u0442\u043A\u0443 ", /*#__PURE__*/_react["default"].createElement("a", {
        href: POLICY_URL,
        target: "_blank",
        rel: "noreferrer"
      }, "\u043F\u0435\u0440\u0441\u043E\u043D\u0430\u043B\u044C\u043D\u044B\u0445 \u0434\u0430\u043D\u043D\u044B\u0445")), /*#__PURE__*/_react["default"].createElement(Button, {
        type: "primary",
        text: "\u041E\u0442\u043F\u0440\u0430\u0432\u0438\u0442\u044C",
        disabled: nameIsEmpty || !phoneIsValid
      })), /*#__PURE__*/_react["default"].createElement(_throbber["default"], {
        waitStatus: waitStatus
      })));
    }
  }]);

  return PopupCallback;
}(_react.Component);

_defineProperty(PopupCallback, "defaultProps", {
  onSuccessShow: function onSuccessShow() {
    return;
  },
  onFailureShow: function onFailureShow() {
    return;
  },
  label: ''
});

var _default = PopupCallback;
exports["default"] = _default;